import search from '../../../components/searchIndex.vue'
import {store} from '../../../store/store.js'
import {CommonUtil} from "../../../common/CommonUtil.js";
import {api} from "../../../common/config.js";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
export default {
  name:'libraryNav',
  data(){
    return {
      pointer:1,//计算栏目的个数
      activeNav: '本馆介绍',
      type: store.webType,
      resource:'/search/searchlibrary',//高级搜索url
      dataxx:"大家圣诞节上课",
      libName:'',
      libCode:'',
      libLevel:'',
      libId:0,
      latLng:'',
      keyword:'',
      locationCode:'',
      isBackClick: true,
      logo:'',
      count:0,
      navs: [{
        name: '本馆介绍',
        url: '/introduce',

      }, {
        name: '图书',
        url: '/library/book/1',

      }, {
        name: '电子书',
        url: '/library/book/2',
      }, {
        name: '本馆资讯',
        url: '/library/inforlist',

      }, {
        name: '本馆活动',
        url: '/library/activitylist',

      }, {
        name: '读者留言',
        url: '/library/readercomments',

      }],
    }
  },
  components:{
    search
  },
  watch : {
    $route() {
      this.libCode = this.$route.query.libCode || this.$route.query.hallCode;
      this.libId =  this.$route.query.libId;
      this.fromSearch = this.$route.query.fromSearch;
      this.libName = this.$route.query.libName;
      this.libLevel = this.$route.query.libLevel;
      this.latLng = this.$route.query.latLng;
      this.locationCode = this.$route.query.locationCode;
      this.logo =  this.$route.query.logo;
    }
  },
  beforeMount() {
    this.queryData();
    store.libraryNav = this;
    store.wrap.activeRouteName = '图书馆';
  },
  methods:{
    chooseNav(nav) {
      this.activeNav = nav.name
    },

    queryData:function () {
        this.keyword = this.$route.query.searchStr || '';
        this.latLng = this.$route.query.latLng || store.localtionArea.latLng;
        this.libName = this.$route.query.libName;
        this.libCode = this.$route.query.libCode || this.$route.query.hallCode;
        this.libLevel = this.$route.query.libLevel;
        this.libId = this.$route.query.libId || 0;
        this.locationCode = this.$route.query.locationCode || store.chooseArea.code;
        this.logo = this.$route.query.logo;
        Promise.all([this.getData()]).then(()=>{
            if (this.count>0){
                this.navs=[{
                    name: '本馆介绍',
                    url: '/introduce',

                }, {
                    name: '图书',
                    url: '/library/book/1',

                }, {
                    name: '电子书',
                    url: '/library/book/2',
                }, {
                    name: '本馆资讯',
                    url: '/library/inforlist',

                }, {
                    name: '本馆活动',
                    url: '/library/activitylist',

                }, {
                    name: '总分馆',
                    url: '/library/librarypart',
                }, {
                    name: '读者留言',
                    url: '/library/readercomments',
                }];
            }
        })
    },

    getData(){
        return new Promise((resolve, reject)=> {
            var url = api.library.getAllLibrary.replace('{libCode}', this.libCode).replace('{lngLat}', this.latLng);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                this.count = data.count;
                resolve()
            }, null, this);
        })
    },

    //搜索
    toSearch(value,select){
      value=CommonUtil.Trim(value);
      if(value=="" || value.length==0){
        return;
      }
      var searchType = select?select.type:1;
      this.$router.push({path: '/indexsearch', query: {searchStr: value,fromSearch:1,type:searchType,lngLat:this.lngLat,
          locationCode:this.locationCode,libCode:this.libCode}});
    },
    //高级搜索
    highSearch:function (select) {
      //1:图书，2：电子书，3，图书馆，4活动，5：资讯*/
      var searchType = select?select.type:this.$route.query.type;
      if (searchType == 1) {
        this.$router.push({path: '/searchbook', query: {type: 1,"fromSearch":this.$route.query.fromSearch,libCode:this.libCode, typeId:0 }});
      } else if (searchType == 2) {
        this.$router.push({path: '/searchbook', query: {type: 1,"fromSearch":this.$route.query.fromSearch,libCode:this.libCode, typeId:1 }});
      } else if (searchType == 3) {
        this.$router.push({path: '/searchlibrary', query: {type: 1,"fromSearch":this.$route.query.fromSearch,libCode:this.libCode}});
      }else if (searchType ==5) {
        this.$router.push({path: '/searchbook', query: {type: 1,"fromSearch":this.$route.query.fromSearch,libCode:this.libCode, typeId:2 }});
      }
    },
      /**
       * 导航向左移动一格
      * */
      handlePrev:function(){
          if(this.pointer > this.navs.length - 7){
              return
          }
          document.querySelectorAll('.listnav')[this.pointer - 1].style.display = "none";
          this.pointer = this.pointer + 1;
      },
      /**
       * 导航向右移动一格
       * */
      handleNext:function(){
          if(this.pointer === 1){
              return
          }
          document.querySelectorAll('.listnav')[this.pointer - 2].style.display = "block";
          this.pointer = this.pointer-1;
      }

  }
}
